import * as React from 'react'
import moment from 'moment'

export function NextContactCell({ row }) {
  const request = row.original
  const isPastDue = moment(request.next_contact_date).isBefore(moment()) // Check if next_contact_date is in the past

  return (
    <span className={isPastDue ? 'text-red-500' : ''}>
      {moment(request.next_contact_date).format('L')}
    </span>
  )
}
